import QuestionPanel from "../../structure/QuestionPanel";
import React from "react";
import TextInput from "../../input/TextInput";
import PhoneInput from "../../input/PhoneInput";
import { BenefitType, findPartyChoicesFor } from "../../enums/BenefitType";
import { useFormikContext } from "formik";
import { EmployeeFormValues } from "../../common/EmployeeFormValues";
import AddListElementButton from "../../button/AddListElementButton";
import TreatingPhysician from "../../input/TreatingPhysician";
import { Party } from "../../enums/Party";

function TreatingPhysicianInformation() {
    const { values } = useFormikContext<EmployeeFormValues>();
    const benefitType = values.benefit;
    const showTreatingPhysicians = (findPartyChoicesFor(benefitType).includes(Party.PHYSICIAN) && values.medicalRelated) || [BenefitType.ACCIDENT, BenefitType.CRITICAL_ILLNESS, BenefitType.HOSPITAL_INDEMNITY].includes(benefitType);

    return (
        <QuestionPanel headerText="Please provide the facility and treating physician information."
                       panelContent={<>
                           {[BenefitType.WELLNESS, BenefitType.ACCIDENT, BenefitType.HOSPITAL_INDEMNITY, BenefitType.CRITICAL_ILLNESS].includes(benefitType) && <>
                               <TextInput id="facility-name" label="Facility name" required={false} maxLength={1024}/>
                               <PhoneInput id="facility-phone-number" label="Facility phone number" required={false}/>
                           </>}
                           {showTreatingPhysicians && <AddListElementButton idPrefix="treating-physicians" componentType={TreatingPhysician}
                                                                            elementInitialValue={{
                                                                                physicianFirstName: '',
                                                                                physicianLastName: '',
                                                                                physicianPhoneNumber: ''
                                                                            }}
                                                                            label="Provide the names of all treating physicians."
                                                                            buttonText="Add Physician"
                                                                            otherElementProps={{ required: true }}
                           />}
                       </>}
        >
        </QuestionPanel>
    );
}

export default TreatingPhysicianInformation;